import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from "../hooks/useTranslatable";
import CategoryService from '../services/category.service';


const Informations = ({ currentTherapist, axios, auth }) => {
  console.log({ currentTherapist })
  const [categoriesCurrent, setCategoriesCurrent] = useState([]);
  const translatedSelectedCategories = useTranslatableData(categoriesCurrent);
  const { t, i18n } = useTranslation('product');
  console.log({ categoriesCurrent })
  console.log({ auth })


  useEffect(() => {
    if (currentTherapist?.categories?.length > 0) {
      fetchCategoriesData();
    }
  }, [currentTherapist]);

  const fetchCategoriesData = async () => {
    try {
      const categoryIds = currentTherapist.categories.map(cat => cat.id);

      const response = await CategoryService.index(
        {
          id: `in:${categoryIds.join(',')}`,
          is_active: 1,
          with: 'domain,domain.hotel'
        },
        axios,
        auth?.accessToken ? false : true
      );

      const filteredCategories = response.filter(cat => cat.domain?.hotel?.id === auth.user.hotel[0]?.id);

      setCategoriesCurrent(filteredCategories);
      return filteredCategories;
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategoriesCurrent([]);
    }
  }
  let parsedTags = {};
  try {
    const rawTags = currentTherapist?.tags;
    if (rawTags) {
      parsedTags = typeof rawTags === 'string' ? JSON.parse(rawTags) : rawTags;
    }
  } catch (error) {
    parsedTags = {};
  }

  // Prefer localized bio based on current language (fr/en), fallback to other or legacy string
  const lang = (i18n?.language || 'fr').slice(0, 2);
  const bioText = parsedTags?.bio
    ? (typeof parsedTags.bio === 'string'
      ? parsedTags.bio
      : (parsedTags.bio[lang] || parsedTags.bio.fr || parsedTags.bio.en || ''))
    : '';

  return (
    <div className="modal-therapist">
      <h3 className='info-title'>Informations</h3>
      <div className="informations">

        <h4>Bio</h4>
        <p>{bioText}</p>

      </div>
      {parsedTags?.experience && Array.isArray(parsedTags.experience) && parsedTags?.experience?.length > 0 && (
        <div className="informations">
          <h4>{t('experience')}</h4>
          <ul className='list-soin'>
            {parsedTags.experience.map((experience, index) => <li key={index}>{experience}</li>)}
          </ul>

        </div>
      )}
      <div className="informations">
        <h4>{t('soins')}</h4>
        <ul className='list-soin'>
          {/* {parsedTags?.experience && Array.isArray(parsedTags.experience) ? (
            parsedTags.experience.map((experience, index) => <li key={index}>{experience}</li>)
          ) : (
            <li>Aucune expérience renseignée</li>
          )} */}
          {translatedSelectedCategories?.length > 0 ? (
            translatedSelectedCategories.map((category, index) => (
              <li key={`cat-${index}`}>{category.title}</li>
            ))
          ) : (
            <li>Aucune expérience renseignée</li>
          )}
        </ul>

      </div>
      <div className="informations" style={{marginBottom: "50px"}}>

        <h4>Langue</h4>
        <p>
          {parsedTags?.language && Array.isArray(parsedTags.language) ? (
            parsedTags.language.map((language, index) => (
              <span key={index}>
                {language}
                {index < parsedTags.language.length - 1 ? ", " : ""}
              </span>
            ))
          ) : (
            "Aucune langue renseignée"
          )}
        </p>

      </div>
    </div>
  );
};

export default Informations;
